/* eslint-disable i18next/no-literal-string */

import { BasicAuthenticationCredentials, deserializationPolicy, ServiceClientCredentials } from '@azure/core-http';
import { pageDataService } from 'common/utilities/PageDataService';
import { MicrosoftConsumerSecurityClient } from 'generated/clients/TypeScript/MicrosoftConsumerSecurityClient/v1/src/microsoftConsumerSecurityClient';
import { MicrosoftConsumerSecurityClientOptions } from 'generated/clients/TypeScript/MicrosoftConsumerSecurityClient/v1/src/models/index';

import { IAntiforgeryTokenPolicyOptions } from './AntiforgeryTokenPolicy';
import { AntiforgeryTokenPolicyFactory } from './AntiforgeryTokenPolicyFactory';
import { exceptionCodePolicy } from './ExceptionCodePolicy';
import { telemetryClientHeaderPolicy } from './TelemetryClientHeaderPolicy';

class MicrosoftConsumerSecurityClientFactoryV1 {
  private readonly defaultEmptyBearerTokenCredentials: ServiceClientCredentials;

  private readonly antiforgeryOptions: IAntiforgeryTokenPolicyOptions;

  private readonly clientOptions: MicrosoftConsumerSecurityClientOptions;

  private readonly host: string;

  constructor() {
    // The client within ClientApp does not need bearer auth, but AutoRest requires non-null credentials
    this.defaultEmptyBearerTokenCredentials = new BasicAuthenticationCredentials('dummy username', 'dummy password');

    this.antiforgeryOptions = {
      responseCookieName: 'XSRF-TOKEN',
      requestHeaderName: 'X-XSRF-TOKEN',
    };

    this.clientOptions = {
      baseUri: pageDataService.getConsumerSecurityPortalHost(),
      requestPolicyFactories: [
        telemetryClientHeaderPolicy(),
        new AntiforgeryTokenPolicyFactory(this.antiforgeryOptions),
        exceptionCodePolicy(), // to include exception code in thrown RestError (must be placed before `deserializationPolicy` to catch the error)
        deserializationPolicy({ json: ['application/json', 'text/json', 'text/plain'] }),
      ],
    };

    this.host = 'http://localhost';
  }

  public createMicrosoftConsumerSecurityClient(): MicrosoftConsumerSecurityClient {
    return new MicrosoftConsumerSecurityClient(this.defaultEmptyBearerTokenCredentials, this.clientOptions);
  }
}

const microsoftConsumerSecurityClientFactory = new MicrosoftConsumerSecurityClientFactoryV1();
export const microsoftConsumerSecurityClient = microsoftConsumerSecurityClientFactory.createMicrosoftConsumerSecurityClient();
